<template>
<m-pageframe
    title="Multi-Organization Employee: {employee-label}"
>
<v-container
    fluid
    style="padding: 15px"
>

    <v-data-table
        v-if="employee_labels != null"
        :headers="headers"
        :items="employee_labels"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.is_organization_admin="{ item }">
            <v-simple-checkbox
               disabled
                v-model="item.is_organization_admin"
            />
        </template>

         <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox
               disabled
                v-model="item.is_archived"
            />
        </template>
    
    </v-data-table>

    <m-icon-bar
        v-on:add="onClickAdd"
    />

    <m-multi-org-employee-add-dialog
        ref="add-dialog"
        v-on:update="update"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            employee_labels: [],

            headers: [
                { text: 'Employee', value: 'employee_label'},
                { text: 'Organization', value: 'organization_label'},
                { text: 'Organization Admin', value: 'is_organization_admin'},
                { text: 'Archived', value: 'is_archived'},
            ],
        }
    },

    mounted () {
        this.update();
    },
    
    methods: {
        update() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/employees/multi-org-access-profile/:employee_id',
            
                'params' : {
                        'employee_id': this.$route.params.employee_id,
                    },
            
                'on_success': (data) => {
                        this.employee_labels = data.employee_labels;
                    },
            
                'on_error': 'Unable to get employee multi organization access profile',
            });
        },

        onClickAdd()
        {
            let employee_id = this.employee_labels[0].employee_id;
            let employee_username = this.employee_labels[0].employee_username;
            let employee_label = this.employee_labels[0].employee_label;

            this.$refs['add-dialog'].showDialog(employee_id, employee_username, employee_label);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>